export default __webpack_public_path__ + "static/media/drag-background.771409f0.svg";